module.exports = __webpack_public_path__ + "static/media/noclass.cf6a1bb3.png";